export const ID = 'fc8fdfbb-9aa5-40a6-8c8c-48f1ac80a261';

export const NAME = 'Units Table: StorageMart';
